import React from 'react';
import {lovLabel, FormProps, ClosedContentProps} from 'core/form/formUtils';
import {createForm} from 'core/form/createForm';
import StyledSelect from 'core/components/fields/styledSelect';
import {BlockComp} from 'core/components/blockComp/blockComp';
import ActiveItem from 'core/components/blockComp/activeItem';
import Chip from 'material-ui/Chip';
import {blueGrey50} from "material-ui/styles/colors";
import {observer} from "mobx-react";
import {PartyRole, Party} from "party/partyDomain";
import {action} from "mobx";
import MdEntity from "core/metamodel/mdEntity";
import {LovItem} from "core/metamodel/mdEntity";
import {FieldObjectType} from "core/form/form";


interface PartyRoleFormProps extends FormProps<Party, Party> {
  onChangeRole?: any;
}


const ClosedContent = ({dataObject, entity, entities, fields}: ClosedContentProps<PartyRole>) => (
  <div style={{fontSize: 14, lineHeight: '14px', minHeight: 20}}>
    {lovLabel(dataObject.roleType)}
  </div>
);

@createForm({
  formName: 'PartyRoleForm',
  closedOnNew: true,
  fields: [{
    name: 'roleType',
    usePlaceholder: true,
    setFieldValueFn: (dataObject, value, entity) => dataObject.roles = mergeRoles(dataObject, value, entity),
    getFieldValueFn: (dataObject) => dataObject.roles.map(v => v.roleType)
  }]
}, ClosedContent)
@observer
export default class PartyRoleForm extends React.Component<PartyRoleFormProps, undefined> {


  @action onChangeRoleType = (e) => {
    let {dataObject, formName, onChangeRole} = this.props;

    let form = dataObject.getForm(formName);
    form.getField("roleType" as any).props.onChange(e);
    form.updateFieldsPropValue(dataObject, "roleType");
    if (onChangeRole) onChangeRole();
  };

  render() {
    const {dataObject, rootObject, entities, formName, entity} = this.props;
    let fields: {roleType: FieldObjectType} = dataObject.getFormFields(formName) as any;
    let {roleType} = fields;


    const openContent = (
      <div>
          <StyledSelect {...roleType.props} hintText="Choose values" multi={true} searchable={false} onChange={this.onChangeRoleType}/>
      </div>
    );

    let closedContentArray = (
      <div style={{fontSize: 14, lineHeight: '14px', minHeight: 20, display: 'flex', flexWrap: 'wrap', margin: -4}}>
        {dataObject.roles.map( (role, index) => <Chip key={index} style={{margin: 3, backgroundColor: blueGrey50}}>{lovLabel(role.roleType)}</Chip>)}
      </div>
    );

    const header = (
      <div>
        <span>Roles</span>
      </div>
    );

    let {onChangeRole, ...activeItemProps} = this.props;

    return (
      <BlockComp  noPadding={true} header={header} style={{display: 'flex', flexDirection: 'column'}}>
        <ActiveItem openContent={openContent} closedContent={closedContentArray} {...activeItemProps} />
      </BlockComp>
    );
  }
}


function mergeRoles(party: Party, lovs: LovItem[], partyRoleEntity: MdEntity): PartyRole[] {
  let newArray: PartyRole[] = [];
  for (let role of party.roles) {
    let foundIndex = lovs.findIndex(lov => lov.value === role.roleType.value);
    if (foundIndex >= 0)  {
      newArray.push(role);
      lovs.splice(foundIndex, 1);
    }
  }
  for(let lov of lovs) {
    newArray.push(new PartyRole({$new: true, $added: true, roleType: lov}).initDefaultValues());
  }
  return newArray;
}



// WEBPACK FOOTER //
// ./src/party/component/partyRoleForm.tsx